import { serviceClient, utils, site } from '@yola/ws-sdk';

const POLLING_INTERVAL = 3000;

const initiatePageLocalization = async ({
  pageIds,
  locales,
  translateWithAi,
  ifPageExists,
  pageIdForHomeIfMissing = null,
  onPoll,
}) => {
  const client = serviceClient.get();
  const siteId = site.accessors.getSiteId();

  const response = await client.initiatePageLocalization(siteId, {
    pageIds,
    locales,
    translateWithAi,
    ...(pageIdForHomeIfMissing && { pageIdForHomeIfMissing }),
    ifPageExists,
  });
  const {
    data: { id: jobId },
  } = response;

  return utils.pollAsyncJob({ jobId, interval: POLLING_INTERVAL, onPoll });
};

export default initiatePageLocalization;
